import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchUnassignedLeadsData } from "../../../redux/reducers/apiSlice";
import CmnFilters from "../common/CmnFilters";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { formatDateTime } from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import AddLeadForm from "../AddLeadForm";
import UnassignedLeadMobile from "./UnassignedLeadMobile";
import LeadKeywordStats from "../../automation/automation-lead-keywords/LeadKeywordStats";
import { fetchGymKeywordStatsData } from "../../../redux/prospect-reducers/prospectSlice";
import UTMParams from "../raw-leads/UTMParams";
import LeadFollowupV1 from "../followup/LeadFollowupV1";
import { added_not_added_to_lead_boolean } from "../../common-data/DropdowData";
import { CheckCircleIcon, CrossCircleIcon, CallIcon } from "../../../images/icons/icons";
import LeadJourney from "../lms-v2/lead-journey/LeadJourney";
import ClickToCall from "../lms-v2/lms-payment-links/ClickToCall";

const UnassignedLeads = ({ userInfoData, prevAllFilters }) => {
  const dispatch = useDispatch();
  const { unassignedLeadsLoading, unassignedLeads } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: prevAllFilters.selectedGym
      ? prevAllFilters.selectedGym
      : !isAdmin && !isMarketing && !isClusterManager
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selAddedby: prevAllFilters.selAddedby ? prevAllFilters.selAddedby : "",
    selAssignee: prevAllFilters.selAssginee
      ? prevAllFilters.selAssginee
      : !isAdmin && !isMarketing && !isClusterManager
      ? {
          label: userInfoData?.name || "",
          value: userInfoData?.uid || userInfoData?.user_id || "",
        }
      : "",
    selAutomationKeyword: "",
    selLeadSource:
      prevAllFilters.clickedCard === "referral"
        ? {
            label: "Website Referral",
            value: "website_referral",
          }
        : "",
    selUTMSource: "",
    selCity: "",
    selFilterType: "",
    selAddNotAddToLead:
      prevAllFilters.clickedCard === "wati_leads"
        ? added_not_added_to_lead_boolean[1]
        : "",

    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadAssignDateFrom: "",
    leadAssignDateTo: "",

    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    is_assigned: prevAllFilters.clickedCard === "wati_leads" ? "" : 1,
    auto_gym_map: prevAllFilters.clickedCard === "wati_leads" ? 1 : "",
    filter_type:
      prevAllFilters.clickedCard === "raw_leads" ||
      prevAllFilters.clickedCard === "referral"
        ? "not_added_to_lead"
        : prevAllFilters.clickedCard === "wati_leads"
        ? ""
        : prevAllFilters.clickedCard,
    gym_id: allFilters.selectedGym?.value || "",
    assigned_to: allFilters.selAssignee?.value || "",
    added_by: allFilters.selAddedby?.value || "",
    source_name: allFilters.selLeadSource?.value || "",
    utm_source: allFilters.selUTMSource?.value || "",
    city: allFilters.selCity?.label || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",

    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    assign_date_start: allFilters.leadAssignDateFrom || "",
    assign_date_end: allFilters.leadAssignDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniDatas = {
    pagination: [],
    allLeads: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getAllUnassignedLeads(filters) {
    dispatch(
      fetchUnassignedLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getGymKeywordStats(filters) {
    const { page, limit, auto_gym_map, ...rest } = filters;

    dispatch(
      fetchGymKeywordStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllUnassignedLeads(filters);

    if (prevAllFilters.clickedCard === "wati_leads") {
      getGymKeywordStats(filters);
    }
  }, [filters]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: prevAllFilters.selectedGym
  //       ? prevAllFilters.selectedGym
  //       : !isAdmin && !isMarketing && !isClusterManager
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      assigned_to: allFilters.selAssignee?.value || "",
      added_by: allFilters.selAddedby?.value || "",
      keyword_name: allFilters.selAutomationKeyword?.label || "",
      source_name: allFilters.selLeadSource?.value || "",
      utm_source: allFilters.selUTMSource?.value || "",
      city: allFilters.selCity?.label || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",

      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      assign_date_start: allFilters.leadAssignDateFrom || "",
      assign_date_end: allFilters.leadAssignDateTo || "",
    }));
    setIsPage(0);
  }, [
    allFilters.selectedGym,
    allFilters.selAssignee,
    allFilters.selAddedby,
    allFilters.selAutomationKeyword,
    allFilters.selLeadSource,
    allFilters.selUTMSource,
    allFilters.selCity,
    allFilters.selAddNotAddToLead,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.leadAssignDateFrom,
    allFilters.leadAssignDateTo,
  ]);

  useEffect(() => {
    if (unassignedLeads?.status && unassignedLeads?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: unassignedLeads.data,
        pagination:
          unassignedLeads?.pagination?.length > 0
            ? unassignedLeads.pagination
            : [],
      }));
    } else {
      setAllDatas({
        pagination: [],
        allLeads: [],
      });
    }
  }, [unassignedLeads]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    !isMarketing && {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn"
            style={{
              minWidth: "120px",
              background: row?.added_to_lead ? "#000" : "#C90808",
              color: "#fff",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "15px",
              padding: "10px",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                // modName: row?.added_to_lead ? "followup" : "add",
                modName: row?.added_to_lead ? "view-lead-journey" : "add",
              }))
            }
          >
            {row?.added_to_lead ? "View Lead" : "Add To LMS"}
          </button>
        </div>
      ),
    },
    {
      dataField: "name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    (prevAllFilters.clickedCard === "referral" ||
      prevAllFilters.clickedCard === "wati_leads") && {
      dataField: "gym_id",
      text: "gym name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    prevAllFilters.clickedCard !== "referral" && {
      dataField: "keyword_name",
      text: "keyword name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            <small>{row?.keyword_name || "NA"}</small>
          </span>
        );
      },
    },
    prevAllFilters.clickedCard !== "referral" &&
      prevAllFilters.clickedCard !== "wati_leads" && {
        dataField: "source_name",
        text: "source name",
        formatter: (_, row) => {
          return (
            <span className="tb-data">
              {row?.source_name?.replace(/_/g, " ") || "NA"}
            </span>
          );
        },
      },
    // prevAllFilters.clickedCard === "wati_leads" && {
    //   dataField: "utm_source",
    //   text: "UTM source",
    //   formatter: (_, row) => {
    //     return (
    //       <span
    //         className={`tb-data ${row?.utm_source ? "link" : ""}`}
    //         onClick={() =>
    //           row?.utm_source &&
    //           setModValues({
    //             isModalOpen: true,
    //             modName: "utm_parameters",
    //             rawLeadId: row?.uid,
    //             rowData: row,
    //           })
    //         }>
    //         {row?.utm_source || "NA"}
    //       </span>
    //     );
    //   },
    // },
    prevAllFilters.clickedCard !== "referral" &&
      prevAllFilters.clickedCard !== "wati_leads" && {
        dataField: "assigned_by_id",
        text: "Assigned By",
        formatter: (_, row) => {
          return (
            <span className="tb-data">{row?.assigned_by_name || "NA"}</span>
          );
        },
      },
    prevAllFilters.clickedCard !== "referral" &&
      prevAllFilters.clickedCard !== "wati_leads" && {
        dataField: "is_assigned",
        text: "assigned",
        formatter: (_, row) => {
          return (
            <span className="tb-data icon">
              {row?.is_assigned ? (
                <CheckCircleIcon />
              ) : (
                <CrossCircleIcon />
              )}
            </span>
          );
        },
      },

    prevAllFilters.clickedCard !== "wati_leads" && {
      dataField: "assigned_to_id",
      text: "Assign To",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.assigned_to_name || "NA"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    prevAllFilters.clickedCard !== "referral" &&
      prevAllFilters.clickedCard !== "wati_leads" && {
        dataField: "assigned_date",
        text: "assign date",
        formatter: (_, row) => {
          return (
            <span className="tb-data minWidth100">
              {row?.assigned_date ? formatDateTime(row.assigned_date) : "-"}
            </span>
          );
        },
      },
    {
      dataField: "click_to_call",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "click-to-call",
                  rowData: row,
                }))
              }
            >
              <CallIcon color="#000" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "add"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "utm_parameters"
              ? "mod-width-50p"
              : modValues.modName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : modValues.modName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : "add-new-lead-form"
          }`}
        >
          {modValues.modName === "add" || modValues.modName === "click-to-call" ? null : modValues.modName === "view-lead-journey" ? (
            <ModalHeadAndClose
              title={`Lead Details - ${modValues.rowData?.name || ""}`}
              onClose={onCloseModal}
            />
          ) : (
            <ModalHeadAndClose
              title={
                modValues.modName === "utm_parameters"
                  ? "UTM Parameters"
                  : modValues.modName === "followup"
                  ? "Follow-up"
                  : "Add To LMS"
              }
              onClose={onCloseModal}
            />
          )}

          {modValues.modName === "utm_parameters" ? (
            <UTMParams rowData={modValues.rowData} />
          ) : modValues.modName === "followup" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeFollowupModal={onCloseModal}
              // pageName="wati"
              // prevFilters={(({ limit, page, added_to_lead, ...rest }) => rest)(
              //   filters
              // )}
            />
          ) : modValues.modName === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              rowData={modValues.rowData}
            />
          ) : (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={() => {
                getAllUnassignedLeads(filters);
              }}
              rowData={modValues.rowData}
              isUnassignedRawLead={true}
              clickedCard={prevAllFilters.clickedCard}
            />
          )}
        </div>
      </Modal>

      <CmnFilters
        from={"raw-lead"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        isAdminView={true}
        isFromLeadManagement={true}
        clickedCard={prevAllFilters.clickedCard}
      />

      {prevAllFilters.clickedCard === "wati_leads" && <LeadKeywordStats />}

      {unassignedLeadsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
            <PaymentLinkTable
              tableData={allDatas.allLeads}
              tableColumns={tbColumns}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </div>
          <div className="lead-logs-card-container only-mobile">
            <UnassignedLeadMobile
              tableData={allDatas.allLeads}
              setModValues={setModValues}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              userInfoData={userInfoData}
              clickedCard={prevAllFilters.clickedCard}
            />
          </div>
        </>
      )}
    </>
  );
};

export default UnassignedLeads;
